import {AsyncValidatorFn} from '../interfaces/Validator';
import _ from 'lodash';
import {forkJoin, Observable, throwError} from 'rxjs';
import {switchMap} from 'rxjs/operators';

let asyncValidation$: Observable<string>;

export function asyncValidatorFormat(formats: AsyncValidatorFn | AsyncValidatorFn[] | null, parseStrict) {
    const asyncValidator = setAsyncValidators(formats);
    
    return this.test('asyncValidation', 'failed', function (value) {
        
        asyncValidation$ = asyncValidator(value);
        const {path, createError} = this;
        
        
        // const { some, more, args } = anyArgsYouNeed;
        // [value] - value of the property being tested
        // [path]  - property name,
        // ...
        return asyncValidation$
                .pipe(
                        switchMap((err: string | string[]) =>
                                throwError(createError({path: path, message: err}))
                        ))
                .toPromise();
        
        
    });
};


/**
 * Sets the async types that are active on this control. Calling this
 * overwrites any existing async types.
 */
const setAsyncValidators = (asyncValidators: AsyncValidatorFn | AsyncValidatorFn[] | null): any => {
    return _.isArray(asyncValidators)
            ? composeAsync(<AsyncValidatorFn[]>asyncValidators)
            : <AsyncValidatorFn>asyncValidators || null;
};

/** @internal */
const composeAsync = (asyncValidators: AsyncValidatorFn[]): AsyncValidatorFn | null => {
    if (!asyncValidators) return null;
    const presentValidators: AsyncValidatorFn[] = asyncValidators.filter((o: any) => o !== null) as any;
    if (presentValidators.length === 0) return null;
    
    return function (value): Observable<any> {
        
        const observables = executeAsyncValidators(value, presentValidators);
        
        return forkJoin(observables);
        
    };
};

/** @internal */
// const mergeErrors = (arrayOfErrors: any): string => {
//   console.log(arrayOfErrors)
//   return _.reduce(arrayOfErrors, (result: string[] | null, err: string | null) => {
//     if (err) {
//       result = result.concat([err]);
//     }
//     return result;
//   }, []);
//
// };

/** @internal */
const executeAsyncValidators = (value, validators: AsyncValidatorFn[]): any[] => {
    return validators.map(v => v(value));
};
